export default __webpack_public_path__ + "static/media/windrad.5ba283ab.jpg";